import { BaseResponse } from './base.response';

export class SubmitOrderResponse extends BaseResponse {

  public orderTotal: number;
  public salesOrder: string;

}
